import { render, staticRenderFns } from "./FixedPlugin.vue?vue&type=template&id=36ebc01b"
import script from "./FixedPlugin.vue?vue&type=script&lang=js"
export * from "./FixedPlugin.vue?vue&type=script&lang=js"
import style0 from "./FixedPlugin.vue?vue&type=style&index=0&id=36ebc01b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports